import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CmsBlock} from '../models/cms-blocks';
import {createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';
import * as CmsActions from '../actions/cms.actions';

export interface State extends EntityState<CmsBlock> {
}

export const adapter: EntityAdapter<CmsBlock> = createEntityAdapter<CmsBlock>();

export const initialState: State = adapter.getInitialState({});

export const selectCmsState = createFeatureSelector<State>('cms');

export const cmsBlockReducer = createReducer(
    initialState,
    on(CmsActions.loadCmsBlockSuccess, (state, { block }) => {
        return adapter.addOne(block, {
            ...state,
        });
    }),
    on(CmsActions.loadCmsBlocksSuccess, (state, { cmsBlocks }) => {
        return adapter.addMany(cmsBlocks, {
            ...state,
        });
    }),
);

const {selectAll} = adapter.getSelectors();

export const getAllBlocks = createSelector(
    selectCmsState,
    selectAll
);
